module.exports = __webpack_public_path__ + "static/img/内蒙古银行@2x.ce74bfcb.png";